import { render, staticRenderFns } from "./BasicBtn.vue?vue&type=template&id=34fae102&scoped=true&"
import script from "./BasicBtn.vue?vue&type=script&lang=js&"
export * from "./BasicBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fae102",
  null
  
)

export default component.exports